<template>
  <div>
      <b-card>
          <b-card-header>Inställningar Fortnox</b-card-header>
          <b-card-body>
              <b-row>
                  <b-col>
                      <label></label>

                  </b-col>
              </b-row>
          </b-card-body>
      </b-card>
  </div>
</template>

<script>
export default {
    // props: { tenantcode },

}
</script>

<style>

</style>